import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { DeclineReasonDirection } from '../../enums/decline-reason-direction.enum';
import { DeclineReason } from '../../interfaces/decline-reason';
import * as DeclineReasonsActions from './decline-reasons.actions';

export const declineReasonsFeatureKey = 'decline-reasons';

export interface State extends EntityState<DeclineReason> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<DeclineReason> = createEntityAdapter<DeclineReason>();

export const initialState: State = adapter.getInitialState({
  loading: false,
  error: null,
});

export const declineReasonsReducer = createReducer(
  initialState,
  on(DeclineReasonsActions.loadDeclineReasons, (state) => ({
    ...state,
    loading: state.ids.length === 0,
  })),
  on(DeclineReasonsActions.loadDeclineReasonsSuccess, (state, action) =>
    adapter.upsertMany(
      [
        ...action.declineReasons,
        {
          id: 0,
          reason: 'company-tool.views.jobs.application.activities.decline-reasons.both.others',
          direction: DeclineReasonDirection.BOTH,
        },
      ],
      { ...state, loading: false }
    )
  ),
  on(DeclineReasonsActions.loadDeclineReasonsFailure, (state, action) => ({
    ...state,
    error: action.error,
    loading: false,
  }))
);

export const selectDeclineReasonsState = createFeatureSelector<State>(declineReasonsFeatureKey);

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors(selectDeclineReasonsState);

export const selectDeclineReasonsAll = selectAll;
export const selectDeclineReasonsTotal = selectTotal;
export const selectDeclineReasonsEntities = selectEntities;
export const selectDeclineReasonsIds = selectIds;

export const selectDeclineReasonsByDirection = (direction: DeclineReasonDirection) =>
  createSelector(selectDeclineReasonsAll, (declineReasons) =>
    declineReasons.filter(
      (declineReason) =>
        declineReason.direction === direction || declineReason.direction === DeclineReasonDirection.BOTH
    )
  );
export const selectDeclineReasonsLoading = createSelector(selectDeclineReasonsState, (state) => state.loading);
